module.exports = __webpack_public_path__ + "static/media/logo.24ed9f12.svg";